import * as consts from '../constants';
import * as commonActions from './commonActions';

import tariffApi from '../api/tariffApi';

export function loadTariffsSuccess(pagingModel) {
    return { type: consts.ACTONS.LOAD_TARIFFS_SUCCESS, pagingModel };
}

export function loadTariffsFailed() {
    return { type: consts.ACTONS.LOAD_TARIFFS_FAILED };
}

export function loadTariffsByNetwork(networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.loadTariffsByNetwork(getState().authenticationState.token, networkId).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffsFailed());
            throw (error);
        });
    };
}

export function loadTariffs(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.loadTariffs(getState().authenticationState.token, pagingModel).then(res => {
            res.code = pagingModel.code;
            res.label = pagingModel.label;
            res.showClosed = pagingModel.showClosed;
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffsSuccess(res));
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffsFailed());
            throw (error);
        });
    };
}

export function loadActiveTariffs() {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.loadActiveTariffs(getState().authenticationState.token).then(activeTariffs => {
            dispatch(commonActions.unlockScreen());
            return activeTariffs;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadTariff(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.loadTariff(getState().authenticationState.token, id).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveTariff(tariff) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.saveTariff(getState().authenticationState.token, tariff).then(savedTariff => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffs(getState().tariffState));
            return savedTariff;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function deleteTariff(tariffId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.deleteTariff(getState().authenticationState.token, tariffId).then(() => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffs(getState().tariffState));
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function cloneTariff(tariffId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.cloneTariff(getState().authenticationState.token, tariffId).then((clonedTariffId) => {
            dispatch(commonActions.unlockScreen());
            return clonedTariffId;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

// ******************************************************************************************************************************
//                                      Tariff Group
// ******************************************************************************************************************************

export function loadTariffGroupsSuccess(pagingModel) {
    return { type: consts.ACTONS.LOAD_TARIFF_GROUPS_SUCCESS, pagingModel };
}

export function loadTariffGroupsFailed() {
    return { type: consts.ACTONS.LOAD_TARIFF_GROUPS_FAILED };
}

export function loadTariffGroups(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.loadTariffGroups(getState().authenticationState.token, pagingModel).then(res => {
            res.code = pagingModel.code;
            res.name = pagingModel.name;
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffGroupsSuccess(res));
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffGroupsFailed());
            throw (error);
        });
    };
}

export function loadAllTariffGroups() {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.loadAllTariffGroups(getState().authenticationState.token).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffGroupsFailed());
            throw (error);
        });
    };
}

export function loadTariffGroupsForSocio(networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.loadTariffGroupsForSocio(getState().authenticationState.token, networkId).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadTariffGroupsFailed());
            throw (error);
        });
    };
}

export function deleteTariffGroup(groupId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.deleteTariffGroup(getState().authenticationState.token, groupId).then(() => {
            dispatch(loadTariffGroups(getState().tariffGroupState));
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveTariffGroup({ id, name, code }) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return tariffApi.saveTariffGroup(getState().authenticationState.token, { id, name, code }).then(() => {
            dispatch(loadTariffGroups(getState().tariffGroupState));
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}
